import { Card, CardContent } from "@/components/ui/card";
import { Link } from "wouter";
import { Screenplay } from "@/lib/user-types";
import { FileText } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface ScreenplayCardProps {
  screenplay: Screenplay;
}

export function ScreenplayCard({ screenplay }: ScreenplayCardProps) {
  const formattedDate = formatDistanceToNow(new Date(screenplay.uploadedAt), { addSuffix: true });
  
  return (
    <li className="py-4">
      <div className="flex items-center space-x-4">
        <div className="flex-shrink-0">
          <FileText className="h-6 w-6 text-gray-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-gray-900 truncate">
            {screenplay.title}
          </p>
          <p className="text-sm text-gray-500 truncate">
            Uploaded {formattedDate}
          </p>
        </div>
        <div>
          <Link href={`/screenplays/${screenplay.id}`}>
            <a className="inline-flex items-center shadow-sm px-2.5 py-0.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50">
              View
            </a>
          </Link>
        </div>
      </div>
    </li>
  );
}
